import { useSelector } from 'react-redux';

import { getClientAgeAtAssessment } from '../utils';

import type { RootState } from '../../../../../../store';

export default function useAssessmentClientAge(assessmentDate: string | null) {
  const dob = useSelector((state: RootState) => state.treatmentPlans.current?.client?.dob);
  return getClientAgeAtAssessment(dob, assessmentDate);
}
